// extracted by mini-css-extract-plugin
export default {"articleHeaderEditorContainer":"WriteArticleTitle_articleHeaderEditorContainer__P0gRS","articleHeaderEditor":"WriteArticleTitle_articleHeaderEditor__u8FHt"};